/**
 * Slowniki i formatowanie dla "Faktury z KSeF" (faktury zakupu pobrane z KSeF jako nabywca).
 * Kontrakt = backend/api/ksef_otrzymane.py (zrodlo prawdy). Kwoty/daty 1:1 z kontroli faktur (reuzycie).
 * Tylko tokeny kolorow var(--...) z v3sys-theme.css.
 */
import { dzisISO, dniWsteczISO, poczatekRokuISO } from '../kontrola-faktur/format';

export {
  formatujKwote, formatujDate, formatujDateCzas, formatujMiesiac, dataISO, dzisISO, dniWsteczISO, poczatekRokuISO,
} from '../kontrola-faktur/format';

/** Domyslnie ostatnie 90 dni; "caly czas" = poczatek pobierania z KSeF (KSEF_OTRZYMANE_OD w backendzie,
 *  podsumowanie.ustawienia.od_domyslne - decyzja wlasciciela 2026-09-13). */
export const DOMYSLNE_DNI = 90;
export const OD_CALEJ_HISTORII = '2026-04-01';

export const SZYBKIE_ZAKRESY = [
  { id: '30', etykieta: '30 dni', od: () => dniWsteczISO(30) },
  { id: '90', etykieta: '90 dni', od: () => dniWsteczISO(DOMYSLNE_DNI) },
  { id: 'rok', etykieta: 'bieżący rok', od: () => poczatekRokuISO() },
  { id: 'wszystko', etykieta: 'cały czas', od: () => OD_CALEJ_HISTORII },
];
export const domyslnyZakres = () => ({ od: dniWsteczISO(DOMYSLNE_DNI), do: dzisISO() });

/** Ilosc: bez zbednych zer, przecinek polski; null -> '—'. */
export const formatujIlosc = (ilosc) => {
  if (ilosc === null || ilosc === undefined || ilosc === '' || Number.isNaN(Number(ilosc))) return '—';
  return Number(ilosc).toLocaleString('pl-PL', { minimumFractionDigits: 0, maximumFractionDigits: 3 });
};

/** Statusy wiersza (kontrakt GET /ksef/otrzymane; podsumowanie.statusy ma te same klucze). */
export const STATUSY = {
  nowa: { etykieta: 'Nowa', kolor: 'var(--warning)', tlo: 'var(--warning-light)' },
  dopasowana: { etykieta: 'Dopasowana', kolor: 'var(--info)', tlo: 'var(--info-light)' },
  dodana: { etykieta: 'Dodana', kolor: 'var(--success)', tlo: 'var(--success-light)' },
  koszt: { etykieta: 'Koszt', kolor: 'var(--purple)', tlo: 'var(--purple-light)' },
  pominieta: { etykieta: 'Pominięta', kolor: 'var(--text-secondary)', tlo: 'var(--bg)' },
  blad: { etykieta: 'Błąd', kolor: 'var(--danger)', tlo: 'var(--danger-light)' },
};

/** Kafelki liczb per status - kolejnosc na stronie; `licznik` = klucz w podsumowanie.statusy ('razem' = podsumowanie.razem),
 *  `filtr` = wartosc ?status= (null = wszystkie). */
export const KAFELKI_STATUSOW = [
  { id: 'wszystkie', etykieta: 'Wszystkie', licznik: 'razem', filtr: null, kolor: 'var(--primary)', tlo: 'var(--primary-light)' },
  { id: 'nowa', etykieta: 'Nowe do rozliczenia', licznik: 'nowa', filtr: 'nowa', kolor: 'var(--warning)', tlo: 'var(--warning-light)' },
  { id: 'dopasowana', etykieta: 'Dopasowane', licznik: 'dopasowana', filtr: 'dopasowana', kolor: 'var(--info)', tlo: 'var(--info-light)' },
  { id: 'dodana', etykieta: 'Dodane', licznik: 'dodana', filtr: 'dodana', kolor: 'var(--success)', tlo: 'var(--success-light)' },
  { id: 'koszt', etykieta: 'Koszty', licznik: 'koszt', filtr: 'koszt', kolor: 'var(--purple)', tlo: 'var(--purple-light)' },
  { id: 'pominieta', etykieta: 'Pominięte', licznik: 'pominieta', filtr: 'pominieta', kolor: 'var(--text-secondary)', tlo: 'var(--bg)' },
  { id: 'blad', etykieta: 'Błędy', licznik: 'blad', filtr: 'blad', kolor: 'var(--danger)', tlo: 'var(--danger-light)' },
];

/** Rodzaje faktur FA(3) (pole RodzajFaktury; backend normalizuje do tych kluczy). Filtr ?rodzaj= przyjmuje tez 'korekty'. */
export const RODZAJE = {
  VAT: { etykieta: 'Faktura', pelna: 'Faktura VAT', kolor: 'var(--text)', tlo: 'var(--bg)' },
  KOR: { etykieta: 'Korekta', pelna: 'Faktura korygująca', kolor: 'var(--orange)', tlo: 'var(--orange-light)' },
  ZAL: { etykieta: 'Zaliczkowa', pelna: 'Faktura zaliczkowa', kolor: 'var(--info)', tlo: 'var(--info-light)' },
  ROZ: { etykieta: 'Rozliczeniowa', pelna: 'Faktura rozliczeniowa', kolor: 'var(--info)', tlo: 'var(--info-light)' },
  UPR: { etykieta: 'Uproszczona', pelna: 'Faktura uproszczona', kolor: 'var(--text-secondary)', tlo: 'var(--bg)' },
  KOR_ZAL: { etykieta: 'Kor. zaliczkowej', pelna: 'Korekta faktury zaliczkowej', kolor: 'var(--orange)', tlo: 'var(--orange-light)' },
  KOR_ROZ: { etykieta: 'Kor. rozliczeniowej', pelna: 'Korekta faktury rozliczeniowej', kolor: 'var(--orange)', tlo: 'var(--orange-light)' },
};
export const RODZAJE_KOREKT = new Set(['KOR', 'KOR_ZAL', 'KOR_ROZ']);
/** Wiersz jest korekta: pole `korekta` z backendu, zapasowo po rodzaju. */
export const jestKorekta = (w) => (typeof w?.korekta === 'boolean' ? w.korekta : RODZAJE_KOREKT.has(w?.rodzaj));

/** Sugestia backendu (dopasowanie.sugestia / wiersz.sugestia), co zrobic z faktura. Wartosci: 'zakup' | 'koszt' | 'korekta'. */
export const SUGESTIE = {
  zakup: { etykieta: 'towar (do magazynu)', opis: 'Dostawca towarowy (SFD albo znany z faktur zakupu) — dodaj jako fakturę zakupu', kolor: 'var(--success)', tlo: 'var(--success-light)' },
  koszt: { etykieta: 'koszt (księgowość)', opis: 'Dostawca spoza magazynu — faktura kosztowa (etap 2: księgowość)', kolor: 'var(--purple)', tlo: 'var(--purple-light)' },
  korekta: { etykieta: 'korekta', opis: 'Korekta z KSeF — tylko podgląd; dodawanie korekt SFD przez Kontrolę korekt', kolor: 'var(--orange)', tlo: 'var(--orange-light)' },
};

/** Etykieta sposobu dopasowania pozycji do produktu (szczegoly: pozycje[].dopasowanie). */
export const DOPASOWANIA = { ean: 'po EAN (GTIN z XML)', kod: 'po kodzie SFD (nauka)', nazwa: 'po nazwie', pdf: 'po PDF' };

/**
 * Numer KSeF: 'NIP-RRRRMMDD-XXXXXXXXXXXX-XX' (35 znakow) - w tabeli pokazujemy koncowke,
 * pelny numer w tooltipie.
 */
export const skrocNumerKsef = (numer) => {
  const t = String(numer || '').trim();
  if (!t) return '';
  const czesci = t.split('-');
  if (czesci.length < 3) return t.length <= 18 ? t : `…${t.slice(-16)}`;
  return `…${czesci.slice(-2).join('-')}`;
};

/** Skrot tekstu do tabeli (pelny w tooltipie). */
export const skroc = (tekst, maks = 40) => {
  const t = String(tekst || '').trim();
  if (!t) return '';
  return t.length > maks ? `${t.slice(0, maks - 1).trimEnd()}…` : t;
};

/**
 * Sklep sugerowany dla wiersza (do modalu "Dodaj"): z dopasowanej faktury w systemie (dopasowanie.faktura),
 * a gdy jej nie ma - z wiersza kontroli faktur SFD (dopasowanie.kontrola.sklep_id, adres dostawy z portalu).
 * Zwraca {id, nazwa|null, zrodlo: 'faktura'|'kontrola'} albo null.
 */
export const sklepWiersza = (w) => {
  const dop = w?.dopasowanie || {};
  const f = dop.faktura;
  if (f && f.sklep_id !== null && f.sklep_id !== undefined) return { id: f.sklep_id, nazwa: f.sklep || null, zrodlo: 'faktura' };
  const k = dop.kontrola;
  if (k && k.sklep_id !== null && k.sklep_id !== undefined) return { id: k.sklep_id, nazwa: null, zrodlo: 'kontrola' };
  return null;
};

/** Faktura w systemie dla wiersza listy: {id, numer, sklep, kwota_zgodna} albo null (id z faktura_zakupowa_id, numer z dopasowanie.faktura). */
export const fakturaWSystemie = (w) => {
  const f = w?.dopasowanie?.faktura || null;
  const id = w?.faktura_zakupowa_id ?? f?.id ?? null;
  if (!id && !f) return null;
  return { id, numer: f?.numer || null, sklep: f?.sklep || null, kwota_zgodna: w?.dopasowanie?.kwota_zgodna ?? null };
};

/** Tooltip pigulki statusu: powod pominiecia / blad XML / blad dopasowania. */
export const tooltipStatusu = (w) => {
  if (!w) return undefined;
  if (w.status === 'pominieta' && w.powod_pominiecia) return `Powód: ${w.powod_pominiecia}`;
  if (w.status === 'blad') return w.xml_blad || w.dopasowanie?.blad || undefined;
  if (w.status === 'dopasowana' && w.dopasowanie?.kwota_zgodna === false) return 'Faktura jest w systemie, ale kwota brutto się różni';
  return undefined;
};

/** Komunikat bledu akcji - tresc z backendu ma pierwszenstwo (cialo odpowiedzi w err.data: error/komunikat/message). */
export const komunikatBledu = (err, domyslny = 'Nie udało się wykonać operacji.') => {
  const zSerwera = err?.data?.komunikat || err?.data?.error || err?.data?.message;
  if (err?.errorCode === 'SYNC_W_TOKU') return zSerwera || 'Pobieranie z KSeF już trwa — poczekaj chwilę.';
  if (err?.errorCode === 'KSEF_BRAK_KONFIGURACJI') return zSerwera || 'Brak tokenu albo NIP w ustawieniach KSeF — sprawdź zakładkę KSeF.';
  if (err?.errorCode === 'KSEF_AUTORYZACJA') return zSerwera || 'KSeF odrzucił token — sprawdź token w zakładce KSeF.';
  if (err?.errorCode === 'KSEF_API') return zSerwera || 'KSeF nie odpowiada poprawnie — spróbuj za chwilę.';
  if (err?.status === 403 || err?.isPermissionError) return 'Ta zakładka jest tylko dla administratora.';
  return zSerwera || err?.message || domyslny;
};

/** Pola pomocnicze bledu (brakujace, dopasowane, istniejaca): backend daje je w ciele odpowiedzi (err.data). */
export const daneBledu = (err) => (err?.data?.data && typeof err.data.data === 'object' ? err.data.data : (err?.data || {}));
